'use strict';

var dialog = angular.module('dash.siteSelector.dialog', []);
dialog
.controller('SiteSelectorPromptDialogController', require('./dialog/SiteSelectorPromptDialogController'))
.directive('siteSelectorPromptDialog', require('./dialog/SiteSelectorPromptDialogDirective'));

var siteSelector = angular.module('dash.siteSelector', ['dash.siteSelector.dialog']);

siteSelector
.controller('SiteSelectorController', require('./SiteSelectorController'))
.directive('siteSelector', require('./SiteSelectorDirective'))

//Flux Actions and Store
.factory('SiteSelectorActions', require('./SiteSelectorActions'))
.factory('SiteSelectorStore', require('./SiteSelectorStore'))

//Bind store to actions through init method
.run(['SiteSelectorStore', function (SiteSelectorStore) {
  SiteSelectorStore.init();
}]);


// WEBPACK FOOTER //
// ./src/app/dash/siteSelector/index.js